import React, { Component } from "react";
import { Row, Col, Label } from "reactstrap";
import { observer, inject } from "mobx-react";
import _ from "lodash";

@inject("store")
@observer
export class ComboSelectList extends Component {
    constructor(props) {
        super(props)
    }
    /*TODO
    O selected desse componente não está funcionando. 
    Deve ser algum problema no mobx. O select é utilizado no modal de analise crítica. Porém não funcionou como deveria.
    */
    render() {
        return (
            <div>
                <Row className="pb-0 mt-2">
                    {this.props.title && <Col sm={12}><Label>{this.props.title}</Label></Col>}
                </Row>
                <Col className="grupoCnpjs mb-5">
                    <Row className="pb-0">
                        <Col className="grupoCnpjs-container">
                            {this.props.list && this.props.list.map((i, index) =>
                                <Row className="align-items-center justify-content-between pb-2 px-3"
                                    key={index}
                                    onClick={() => this.props.onClickOnRow(index)}>
                                    {
                                        this.props.formatRow
                                            ? <Col sm={8}>{this.props.formatRow(i[this.props.itenList])}</Col>
                                            : i[this.props.itenList]
                                    }
                                    {
                                        this.props.checkBox &&
                                        <Col className='pr-0 d-flex justify-content-end checkbox-col'>
                                            <label className="control control-checkbox">
                                                <span>
                                                    <input type="checkbox"
                                                        className={this.props.classOnSelect ? 'atualizar' : ''}
                                                        onClick={() => this.props.onClickOnRow(index)}
                                                        checked={_.get(i, this.props.checkedElement)}
                                                    />
                                                    <div className="control_indicator"></div>
                                                </span>
                                            </label>
                                        </Col>
                                    }
                                </Row>
                            )}
                        </Col>
                    </Row>

                    <Row className="p-3 pr-5 align-items-center control-checkboxes">
                        <Col><span>{this.props.list.length}</span> {this.props.legthTitle}</Col>
                        {
                            this.props.checkAll &&
                            <Col className="d-flex flex-row align-items-center justify-content-end checkbox-col pb-0">
                                <span
                                    onClick={(event) => this.props.checkAll(event)}>
                                    Selecionar todos
                                        </span>
                                <Label className="control control-checkbox">
                                    <span>
                                        <input type="checkbox" onChange={(event) => this.props.checkAll(event)} />
                                        <div className="control_indicator"></div>
                                    </span>
                                </Label>
                            </Col>
                        }
                    </Row>
                    {this.props.errorMessage !== "" && <Col><Label className="label-danger mensagem">{this.props.errorMessage}</Label></Col>}
                </Col>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/modules/comum/components/ComboSelectList.js